import React from "react";
import { useTheme } from "styled-components";
import VideoPlayerButtonComponent from "../../VideoPlayerButton";

const FullScreenToggle = ({ isFullScreen, translate, onFullScreenButtonHandler }) => {
  const theme = useTheme();
  return (
    <VideoPlayerButtonComponent
      src={
        isFullScreen
          ? process.env.PUBLIC_URL + "/images/playback-view-minimize.svg"
          : process.env.PUBLIC_URL + "/images/playback-full-screen.svg"
      }
      alt={isFullScreen ? translate("exit_full_screen") : translate("full_screen")}
      onClickHandler={onFullScreenButtonHandler}
      tooltipDirection="bottom"
      buttonClassName={isFullScreen ? "playbackMinimizeScreen" : "playbackFullScreen"}
      $hoverBackgroundColor={theme.colours.mineShaftGray}
    />
  );
};

export default FullScreenToggle;
